import { render, staticRenderFns } from "./sendingRecords.vue?vue&type=template&id=9f58d64c&scoped=true"
import script from "./sendingRecords.vue?vue&type=script&lang=js"
export * from "./sendingRecords.vue?vue&type=script&lang=js"
import style0 from "./sendingRecords.vue?vue&type=style&index=0&id=9f58d64c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f58d64c",
  null
  
)

export default component.exports